export default {
  AUTHORIZATION: 'ownershipPoaProperty',
  POA_OWNERS: 'poaCustomerIds',
  MUNICIPALITY: 'municipality',
  DISTRICT: 'district',
  COMMUNITY: 'community',
  PLOT_NUMBER: 'plotNumber',
  PLOT_ADDRESS: 'plotAddress',
  IS_BLOCKED: 'isBlocked',
  PROJECT_STATUS: 'projectStatus',
  PROJECT_NAME: 'projectId',
  PROJECT_NAME_MORTGAGE: 'projectNameEn',
  ALLOCATION_TYPE: 'allocationType',
  OWNERSHIP_TYPE_ID: 'ownerShipTypeID',
  ACQUISITION_TYPE: 'acquisitionTypeId',
  MORTGAGE_STATUS: 'isMortgaged',
  RENT_STATUS: 'rentStatus',
  BUILDING_NUMBER: 'buildingNumber',
  BUILDING_NAME: 'buildingNameEn',
  UNIT_NUMBER: 'unitNumber',
  FLOOR_NUMBER: 'floorNumber',
  UNIT_USE: 'unitUse',
  UNIT_TYPE: 'unitType',
  USE_TYPE: 'useType',
  MORTGAGE_TYPE: 'mortgageType',
  NO_OF_ROOMS: 'noOfRoom',
  BEDROOMS: 'bedrooms',
  PROPERTY_REG_NUMBER: 'propertyRegNo',
  UNIT_REG_NUMBER: 'unitRegNo',
  PROJECT_ELMS_ID: 'projectElmsId',
  LAND_USE: 'landUse',
  UNIT_CLASSIFICATION: 'unitClassification',

  // Contracts
  CONTRACT_ID: 'contractId',
  CONTRACT_CLASSIFICATION_TYPE: 'contractClassificationType',
  CONTRACT_STATUS: 'contractStatus',
  CONTRACT_CLASSIFICATION_ID: 'contractClassificationId',
  FROM_DATE: 'fromDate',
  TO_DATE: 'toDate',
  BUILDING_REG_NUMBER: 'buildingRegNumber',
  UNIT_ID: 'unitId',
  UNIT_NUMBER_OR_NAME: 'unitNumberOrName',
  PREMISE_ID: 'premiseId',
  TENANT_PHONE_NUMBER: 'tenantPhoneNumber',
  TENANT_NAME: 'tenantName',
  TENANT_UNIFIED_EID_OR_TL_NUM: 'tenantEidUnifiedOrTLNumber',
  PMA_CLASSIFICATION: 'pmaClassification',
  DATE_OF_SALE: 'dateOfSale',
  PAYMENT_STATUS: 'paymentStatus',

  // Directory
  PROJECT_TYPE: 'type',
  DEVELOPER_NAME: 'developerName',
  BUILDING_USAGE: 'buildingUsage',
  STATUS: 'status',
  PROGRESS_PERCENTAGE: 'progressPercentage',
  PROFESSION_TYPE: 'professionType',
  OWNER_TYPE: 'ownerType',

  // Applications & Tasks
  APPLICATION_ID: 'applicationId',
  APPLICATION_STATUS: 'applicationStatus',
  APPLICATION_TYPE: 'applicationType',
  INITIATOR_NAME: 'initiatorName',
  APPLICATION_START_DATE: 'applicationStartDate',
  APPLICATION_END_DATE: 'applicationEndDate',
  EID_OR_MOI_NUMBER: 'eid',
  TRADE_LICENSE_NUMBER: 'tradeLicenseNo',
  APPLICATION_NAME: 'applicationName',
  PHONE_NUMBER: 'phoneNo',
  EMAIL: 'email',
  TASK_STATUS: 'taskStatus',

  // Project Listing
  PROJECT_NUMBER: 'projectNumber',

  // Surveyor Company
  SURVEYOR_NAME: 'surveyorName',
  REGISTRATION_LICENSE_NO: 'regLicenseNo',

  // PMC user in PMA
  CERTIFICATE_TYPE: 'workflowId',
  PROPERTY_CERTIFICATE_NO: 'certificateNo',

  // Non UAE Users
  PASSPORT_NUM: 'passportNumber',
  NATIONALITY_ID: 'nationalityId',
  MOBILE_NO: 'mobileNo',

  // road
  ROAD: 'road',
  // Certificates
  CERTIFICATE_TYPE_V2: 'certificateType',
  CERTIFICATE_NUMBER: 'certificateNumber',
  CERTIFICATE_DATE: 'certificateDate',
};
